import { jsx as o, jsxs as s } from "react/jsx-runtime";
import { forwardRef as u } from "react";
import { useTranslation as f } from "react-i18next";
import h from "classnames";
import d from "../../icons/PhoneCircle.js";
import b from "../../icons/TelegramCircle.js";
import v from "../../icons/WhatsAppCircle.js";
const g = "forma-ui__social-select__root", N = "forma-ui__social-select__label", w = "forma-ui__social-select__items", x = "forma-ui__social-select__button", C = "forma-ui__social-select__input", T = "forma-ui__social-select__icon", j = "forma-ui__social-select__call", k = "forma-ui__social-select__active", y = "forma-ui__social-select__whatsapp", A = "forma-ui__social-select__telegram", a = {
  root: g,
  label: N,
  items: w,
  button: x,
  input: C,
  icon: T,
  call: j,
  active: k,
  whatsapp: y,
  telegram: A
}, B = u(({ name: l, label: i, onChange: r, value: c = "" }, m) => {
  const { t: n } = f(), _ = [
    { id: "call", name: n("uikit:call"), icon: /* @__PURE__ */ o(d, { className: a.icon }) },
    { id: "telegram", name: "Telegram", icon: /* @__PURE__ */ o(b, { className: a.icon }) },
    { id: "whatsapp", name: "WhatsApp", icon: /* @__PURE__ */ o(v, { className: a.icon }) }
  ];
  return /* @__PURE__ */ s("div", { className: a.root, ref: m, children: [
    /* @__PURE__ */ o("div", { className: a.label, children: i }),
    /* @__PURE__ */ o("div", { className: a.items, children: _.map(({ id: t, name: e, icon: p }) => /* @__PURE__ */ s(
      "label",
      {
        htmlFor: t,
        className: h(a.button, a[t], c === e && a.active),
        title: e,
        children: [
          /* @__PURE__ */ o(
            "input",
            {
              id: t,
              name: l,
              type: "radio",
              onChange: r,
              value: e,
              className: a.input,
              checked: c === e
            }
          ),
          p
        ]
      },
      t
    )) })
  ] });
});
export {
  B as default
};
